import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    question: "Quais cirurgias nasais e dos seios da face são realizadas?",
    answer: "Entre os principais procedimentos estão septoplastia, turbinectomia, sinusectomia, cirurgias endoscópicas e remoção de pólipos nasais. A indicação depende da avaliação médica, exames e sintomas do paciente.",
  },
  {
    question: "Quais cirurgias de adenoide e amígdalas são feitas?",
    answer: "Podem ser indicadas adenoidectomia, amigdalectomia, adenoamigdalectomia, cauterização de cornetos inferiores e frenotomia lingual, conforme o diagnóstico e a necessidade de cada paciente.",
  },
  {
    question: "Existe cirurgia para ronco e apneia do sono?",
    answer: "Sim. Uma das opções cirúrgicas é a uvulopalatofaringoplastia. A indicação depende de avaliação especializada, exames do sono e análise da anatomia das vias aéreas.",
  },
  {
    question: "Quais cirurgias de ouvido são realizadas?",
    answer: "Entre elas estão timpanotomia para tubo de ventilação, estapedectomia, timpanoplastia, mastoidectomia e implante coclear. Cada procedimento tem indicação específica após avaliação otológica e exames complementares.",
  },
  {
    question: "Quais cirurgias de laringe são realizadas?",
    answer: "São realizadas microcirurgias de laringe, cirurgias a laser para cordas vocais, cirurgias microscópicas, remoção de pólipos vocais, papiloma e tumores benignos ou malignos.",
  },
  {
    question: "Como agendar uma avaliação cirúrgica?",
    answer: "A avaliação cirúrgica pode ser agendada pelo botão Agendar avaliação na página de Cirurgias, que direciona para o site específico de cirurgias, ou pelo WhatsApp da clínica.",
  },
  {
    question: "Todo paciente que tem desvio de septo precisa operar?",
    answer: "Não. A cirurgia é considerada quando o desvio causa obstrução nasal importante, sinusites recorrentes, ronco, dificuldade respiratória ou quando o tratamento clínico não resolve bem os sintomas.",
  },
  {
    question: "Crianças podem fazer cirurgia de adenoide e amígdalas?",
    answer: "Sim, quando há indicação médica. As causas mais comuns incluem obstrução respiratória, ronco, apneia do sono, infecções recorrentes e aumento importante de adenoide ou amígdalas.",
  },
  {
    question: "Quais exames ajudam na avaliação otorrinolaringológica?",
    answer: "Podem ser solicitados exames como videonasofibroscopia, videolaringoscopia, videoestroboscopia, tomografias, raio X, audiometria, BERA, exames de otoneurologia, exames para labirintopatias e testes alérgicos.",
  },
  {
    question: "O Dr. Alonso Neto atende quais áreas da otorrinolaringologia?",
    answer: "O atendimento envolve doenças do ouvido, nariz, garganta, voz, laringe, sono, labirinto, alergias respiratórias e avaliação cirúrgica em otorrinolaringologia.",
  },
];

const FAQ = () => {
  return (
    <div data-testid="faq-page">
      <section className="bg-gradient-to-br from-primary via-primary to-primary/85 text-primary-foreground pt-28 md:pt-32 pb-12 md:pb-16 relative overflow-hidden">
        <div className="absolute inset-0 pattern-grid opacity-30" />
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-accent blob" />
        <div className="container-pad relative">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-8 h-px bg-accent" />
            <span className="text-[11px] tracking-[0.3em] text-accent font-semibold uppercase">PERGUNTAS FREQUENTES</span>
          </div>
          <h1 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-tight text-balance">Dúvidas mais comuns</h1>
        </div>
      </section>
      <section className="container-pad py-14 md:py-16">
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white border border-border/60 rounded-2xl px-5 data-[state=open]:shadow-md data-[state=open]:border-accent/40" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-base md:text-lg text-primary font-semibold hover:no-underline">{f.question}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-4 text-sm">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
